import {atom} from 'recoil';

export const BundleAtom = atom({
    key: 'selected',
    default: null,
  });

  export const minutesBalance = atom({
    key: 'minutes',
    default: "-",
  });

  export const dialingNumber = atom({
    key: 'number',
    default: "-",
  });

  export const signupCredentials = atom({
    key: 'signupCredentials',
    default: { email: '', password: '', password2: '', acceptedTerms: false },
  });
